export default {
  Expense: 0, // Thực thi
  Advance: 1, // Tạm ứng
  AdvanceIsEligibleForPayment: 3, // Ứng trước đủ điều kiện thanh toán
  AdvanceIsNotEligibleForPayment: 2, // Ứng trước chưa đủ điều kiện thanh toán
  None: 4, // Không chọn
};
